export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["None"] = "None";
    TicketStatus["Waiting"] = "Waiting";
    TicketStatus["Open"] = "Open";
    TicketStatus["ClosedAttendant"] = "ClosedAttendant";
    TicketStatus["ClosedClient"] = "ClosedClient";
    TicketStatus["ClosedClientInactivity"] = "ClosedClientInactivity";
})(TicketStatus || (TicketStatus = {}));
